import { render } from "./IconLogout.vue?vue&type=template&id=5ba970fa"
const script = {}
script.render = render

export default script